import React, { useState, useEffect } from 'react'
import { Grid, Typography, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import MUIDataTable from 'mui-datatables'

// components
import Widget from '../../components/Widget/Widget'
// import Table from "../../dashboard/components/Table/Table";

import {
    getLGFPortfolioNumber,
    getLGFPortfolioPrice,
    getLGFPortfolioDataTable,
} from './utils.js'

import axios from 'axios'
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'

const useStyles = makeStyles(theme => ({
    tableOverflow: {
        overflow: 'auto',
    },
}))

const cKey = 'ckey_be4a9850cb1b4162b54bb8207d3'

// Contracts
const Farming_Contract = '0x642c9e3d3f649f9fccb9f28707a0260ba1e156b1'

// Create our number formatter.
var formatter = new Intl.NumberFormat()

var formatterUS = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

async function portfolio(chainId, wallet) {
    try {
        return await axios.get(
            `https://effortless-leaf-336220.uc.r.appspot.com/portfolio_v2/${wallet}/${chainId}`
        )
    } catch (error) {
        console.error(error.message)
    }
}

export default function WalletPage(props) {
    const classes = useStyles()

    const [numberAssets, setNumberAssets] = useState(0)

    const [portfolioPrice, setPortfolioPrice] = useState(0)

    const [portfolioLoader, setPortfolioLoader] = useState(0)

    const [portfolioData, setPortfolioData] = useState([])

    useEffect(() => {
        const fetchPortfolio = async contract => {
            setPortfolioLoader(1)
            setPortfolioData([])
            try {
                const response = await portfolio(props.chainId, contract)

                const number = getLGFPortfolioNumber(response)
                const price = getLGFPortfolioPrice(response)
                const datatable = getLGFPortfolioDataTable(response)

                setNumberAssets(number)
                setPortfolioPrice(price)
                setPortfolioData(datatable)
            } catch (error) {
                console.error(error.message)
            }
            setPortfolioLoader(0)
        }

        const refresh = async () => {
            await fetchPortfolio(Farming_Contract)
        }

        refresh()
    }, [])

    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                    <Widget title="Number of Assets" disableWidgetMenu>
                        <div className={classes.dashedBorder}>
                            <Typography variant="h1" className={classes.text}>
                                {!portfolioLoader ? (
                                    formatter.format(numberAssets)
                                ) : (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                )}
                            </Typography>
                        </div>
                    </Widget>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Widget title="Total Amount (USD)" disableWidgetMenu>
                        <div className={classes.dashedBorder}>
                            <Typography variant="h1" className={classes.text}>
                                {!portfolioLoader ? (
                                    formatterUS.format(portfolioPrice)
                                ) : (
                                    <CircularProgress
                                        size={26}
                                        className={classes.loginLoader}
                                    />
                                )}
                            </Typography>
                        </div>
                    </Widget>
                </Grid>
                {/*   <Grid item xs={12} md={4}>
          <Widget title="Profit (USD)" disableWidgetMenu>
            <div className={classes.dashedBorder}>
              <Typography variant="h1" className={classes.text}>
                {!lgfBuyBacksLoader ? (
                  formatterUS.format(
                    lgfBuyBacks > 0 ? lgfBuyBacksPrice / lgfBuyBacks : 0,
                  )
                ) : (
                  <CircularProgress size={26} className={classes.loginLoader} />
                )}
              </Typography>
            </div>
          </Widget>
        </Grid> */}
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <MUIDataTable
                        title="Assets"
                        data={portfolioData}
                        columns={[
                            {
                                name: 'ASSET',
                            },
                            {
                                name: 'PRICE',
                            },
                            {
                                name: 'BALANCE',
                            },
                            {
                                name: 'VALUE',
                                /* options: {
                  customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                      <a
                        target="_blank"
                        href={"https://etherscan.io/tx/" + value}
                      >
                        {value}
                      </a>
                    );
                  },
                }, */
                            },
                        ]}
                        options={{
                            filterType: 'checkbox',
                            selectableRowsHeader: false,
                            selectableRows: 'none',
                            print: false,
                            textLabels: {
                                body: {
                                    noMatch: portfolioLoader ? (
                                        <CircularProgress
                                            size={26}
                                            className={classes.loginLoader}
                                        />
                                    ) : (
                                        'Sorry, there is no data to display'
                                    ),
                                },
                            },
                        }}
                    />
                </Grid>
            </Grid>
            {/* <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget
            title="Material-UI Table"
            upperTitle
            noBodyPadding
            bodyClass={classes.tableOverflow}
          >
            <Table data={mock.table} />
          </Widget>
        </Grid>
      </Grid> */}
        </>
    )
}
